import { useState } from "react";

export const useNetworksToCopy = () => {
  const [networksToCopy, setNetworksToCopy] = useState<number[]>([]);

  const handleNetworkChange = (e: React.ChangeEvent<{ value: number[] }>) => setNetworksToCopy(e.target.value);

  return {
    networksToCopy,
    handleNetworkChange,
  };
};
